'use client';

import { useEffect } from 'react';

import { getAnalyticsPlugin } from './analytics/get-analytics-plugin';

export default function AnalyticsLogger() {
  useEffect(() => {
    function trackClick(event: MouseEvent) {
      const target = event.target as HTMLElement | null;

      const element = target?.closest<HTMLElement>('[data-analytics-event]');

      const { analyticsEvent, analyticsProperties } = element?.dataset || {};

      if (!analyticsEvent) {
        return;
      }

      let properties = {};
      if (analyticsProperties) {
        properties = JSON.parse(analyticsProperties);
      }

      const plugin = getAnalyticsPlugin();

      plugin.track(analyticsEvent, properties);
    }

    document.addEventListener('click', trackClick);

    return () => {
      document.removeEventListener('click', trackClick);
    };
  }, []);

  return <></>;
}
